/**
 * Custom Task model
 *
 * Taken from the vanilla dragfromgrid example
 */
import { EventModel } from '@bryntum/schedulerpro';

export default class QEvent extends EventModel {
    static get defaults() {
        return {
            // in this demo, default duration for tasks will be hours (instead of days)
            durationUnit: 'h'
        };
    }
    static get fields() {
        return [
            { name: 'jobId', type: 'number' },
            { name: 'jobTypeId', type: 'number' },          //readonly
            { name: 'jobTypeName', type: 'string' },        //readonly
            { name: 'jobStatusId', type: 'number' },        //readonly
            { name: 'jobStatusName', type: 'string' },      //readonly
            { name: 'address', type: 'string' },            //readonly
            { name: 'appointmentType', type: 'number' },
            { name: 'durationNum', type: 'string' }, //used on draghelper
            { name: 'loading', type: 'bool' }
        ]
    }
}
